// import { Box, Popover, styled, Typography } from "@mui/material";
// import React, { useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import Logout from "@mui/icons-material/Logout";
// import "./NavBar.css";
// import { ListItemIcon } from "@mui/material";
// import { useDispatch } from "react-redux";
// import { removeToken } from "../../redux/tokenSlice";
// import AuthService from "../../services/auth.service";
// import { useForm } from "react-hook-form";
// import toast from "react-hot-toast";
// import { ClipLoader } from "react-spinners";
// import MenuOpenIcon from "@mui/icons-material/MenuOpen";
// import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
// import CurrentDateAndTime from "./DateAndTime";

// export const NavBar = ({ open, setOpen }) => {
//   const userDetails = JSON.parse(localStorage.getItem("user_detail"));
//   const [isLoading, setIsLoading] = useState(false);
//   const history = useNavigate();
//   const dispatch = useDispatch();
//   const spanInActive = "text-d2cfcf text-font link-hover";
//   // --------------------------------------------------------------------------
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const openPopup = Boolean(anchorEl);
//   const id = openPopup ? "simple-popover" : undefined;
//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleClose = () => {
//     setAnchorEl(null);
//   };
//   const logout = () => {
//     AuthService.logout();
//     dispatch(removeToken);
//     history("/login");
//   };
//   // -----------------------------states for upload in bulk-----------------------

//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//   } = useForm();

//   const handleCSVUploadClick = async (dataFile) => {
//     try {
//       setIsLoading(true);
//       const formData = new FormData();
//       formData.append("file", dataFile.file[0]);
//       const token = localStorage.getItem("token");
//       const res = await fetch("/workflow/api/collection_data", {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: formData,
//       });

//       const resData = await res.json();

//       if (resData?.status === false) {
//         toast.error(resData?.message);
//       } else {
//         toast.success(resData?.message);
//         reset({ file: "" });
//         handleClose(); // Dismiss the modal
//       }
//     } catch (error) {
//       // Handle any errors
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   //-----------------------Upload in bulk ends--------------------------

//   return (
//     <>
//       <div className="text-black  p-2 w-full flex justify-between items-center">
//         <div className="flex md:w-1/2">
//           <div className="grid grid-cols-12 px-4 py-2 w-full">
//             <div className="col-span-5 md:col-span-4 flex items-center gap-4 bg-blue-500">
//               {/* <span className="text-xl font-semibold"></span> */}
//               <Typography
//                 variant="h5"
//                 className="text-blue-900"
//                 noWrap
//                 component="div"
//               >
//                 Bulk WorkFlow
//               </Typography>
//             </div>
//             <div className="">
//               {open && (
//                 <MenuOpenIcon
//                   className="text-blue-900 cursor-pointer"
//                   sx={{ fontSize: 30 }}
//                   onClick={() => setOpen(!open)}
//                 />
//               )}
//               {!open && (
//                 <MenuOutlinedIcon
//                   className="text-blue-900 cursor-pointer"
//                   sx={{ fontSize: 30 }}
//                   onClick={() => setOpen(!open)}
//                 />
//               )}
//             </div>
//             <div className="md:col-span-5 flex-grow hidden lg:flex">
//               {userDetails?.user_category === "Operations" ? (
//                 <>
//                   <NavLink
//                     className="nav-link nav-link-tab text-light text-decoration-underline fw-bolder border-gray-300 "
//                     role="button"
//                     data-bs-toggle="modal"
//                     data-bs-target={`#uploadInBulkModal`}
//                   >
//                     <span
//                       className={`${spanInActive} p-2 rounded-lg`}
//                       style={{ color: "#1e3a8a", border: "1px solid #1e3a8a" }}
//                     >
//                       {" "}
//                       Upload In Bulk
//                     </span>
//                   </NavLink>
//                 </>
//               ) : (
//                 <></>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="hidden items-center md:flex">
//           <div className="relative">
//             <CurrentDateAndTime />
//           </div>
//           <Box className="text-light p-0">
//             <div className="px-4">
//               <AccountCircleIcon
//                 role="button"
//                 sx={{ fontSize: 40, mr: 1, color: "#00213e" }}
//                 aria-describedby={id}
//                 onClick={handleClick}
//               />
//               <span className="font-semibold" style={{ color: "#1e3a8a" }}>
//                 {userDetails?.user_name || "NA"}
//               </span>
//             </div>
//             <Popover
//               sx={{
//                 boxShadow: 5,
//               }}
//               id={id}
//               open={openPopup}
//               anchorEl={anchorEl}
//               onClose={handleClose}
//             >
//               <div className="container ">
//                 <div className="row accountBg pl-5 pr-5 pt-3 ">
//                   <ListItemIcon>
//                     <AccountCircleIcon
//                       className="text-light"
//                       sx={{
//                         fontSize: 85,
//                         borderRadius: 20,
//                         boxShadow: 8,
//                         padding: 0,
//                       }}
//                     />
//                   </ListItemIcon>
//                 </div>
//                 <div className="row accountBg pl-5 pr-5 pt-3 text-center font">
//                   <p className="lead font-weight-bold p-0">
//                     {userDetails?.user_name}
//                   </p>
//                 </div>
//                 <div className="row accountBg pl-5 pr-5 text-center font pb-3">
//                   <span className="small">{userDetails?.user_category}</span>
//                 </div>
//               </div>
//               <div className="row">
//                 <div
//                   className="btn btn-light pt-2 btn-sm fs-6 pb-2 text-dark"
//                   onClick={() => logout()}
//                 >
//                   <ListItemIcon>
//                     <Logout className="fs-4 mt-1" />
//                     <span className="fs-5">Logout</span>
//                   </ListItemIcon>
//                 </div>
//               </div>
//             </Popover>
//           </Box>
//         </div>
//       </div>

//       {/* ------------Modal for Upload in Bulk------------- */}
//       <div
//         className="modal fade"
//         id="uploadInBulkModal"
//         data-bs-backdrop="static"
//         data-bs-keyboard="false"
//         tabIndex="-1"
//         aria-labelledby="uploadInBulkModal"
//         aria-hidden="false"
//       >
//         <div className="modal-dialog">
//           <div className="modal-content position-relative">
//             <div className="modal-header">
//               <h1 className="modal-title fs-5 text-dark" id="uploadInBulkModal">
//                 Upload In Bulk
//               </h1>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>
//             <form onSubmit={handleSubmit(handleCSVUploadClick)}>
//               <div className="modal-body">
//                 <div className="row form-group">
//                   <label
//                     htmlFor="date"
//                     className="col-sm-4 col-form-label pt-1"
//                   >
//                     Select CSV File
//                   </label>
//                   <div className="col-sm-8 pl-0 text-left">
//                     <input
//                       name="fileCSV"
//                       type="file"
//                       accept=".csv,.xlsx"
//                       {...register("file", {
//                         required: "File is required...",
//                       })}
//                     />
//                   </div>
//                 </div>
//                 <div className="row d-flex justify-content-center text-danger">
//                   {errors?.file ? errors?.file?.message : ""}
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   data-bs-dismiss="modal"
//                 >
//                   Close
//                 </button>
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   disabled={isLoading}
//                 >
//                   {isLoading ? (
//                     <div className="d-flex align-items-center">
//                       <ClipLoader color="#ffffff" loading={isLoading} />
//                       <span className="ms-2">Uploading...</span>
//                     </div>
//                   ) : (
//                     "Upload"
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

import {
  Box,
  Popover,
  Typography,
  ListItemIcon,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Logout from "@mui/icons-material/Logout";
import "./NavBar.css";
import { useDispatch } from "react-redux";
import { removeToken } from "../../redux/tokenSlice";
import AuthService from "../../services/auth.service";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CurrentDateAndTime from "./DateAndTime";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { restrictedUser } from "../../utils";

export const NavBar = ({
  open,
  setOpen,
  isSidebarExpanded,
  setIsSidebarExpanded,
}) => {
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const history = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const openPopup = Boolean(anchorEl);
  const id = openPopup ? "simple-popover" : undefined;

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const logout = () => {
    AuthService.logout();
    dispatch(removeToken());
    history("/login");
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleCSVUploadClick = async (dataFile) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", dataFile.file[0]);
      const token = localStorage.getItem("token");
      const res = await fetch("/workflow/api/collection_data", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const resData = await res.json();
      if (resData?.status === false) {
        toast.error(resData?.message);
      } else {
        toast.success(resData?.message);
        reset({ file: "" });
        setOpenModal(false);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    if (!isLoading) {
      setOpenModal(false);
      reset({ file: "" });
    }
  };

  return (
    <>
      <div className="w-full flex items-center justify-between px-4 py-2.5 bg-[gradient-to-r from-white via-gray-50 to-white] shadow-md border-b border-gray-200">
        {/* Left Section */}
        <div className="flex items-center gap-3">
          {/* Toggle button for large screens */}
          <div className="hidden xl:block">
            <IconButton
              onClick={() => setOpen(!open)}
              sx={{
                bgcolor: "rgba(99, 102, 241, 0.1)",
                "&:hover": {
                  bgcolor: "rgba(99, 102, 241, 0.2)",
                  transform: "scale(1.05)",
                },
                transition: "all 0.2s ease-in-out",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              {open ? (
                <MenuOpenIcon sx={{ fontSize: 24, color: "#4f46e5" }} />
              ) : (
                <MenuOutlinedIcon sx={{ fontSize: 24, color: "#4f46e5" }} />
              )}
            </IconButton>
          </div>

          {/* Toggle button for mobile/tablet */}
          <div className="block xl:hidden">
            <IconButton
              onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
              sx={{
                bgcolor: "rgba(99, 102, 241, 0.1)",
                "&:hover": {
                  bgcolor: "rgba(99, 102, 241, 0.2)",
                  transform: "scale(1.05)",
                },
                transition: "all 0.2s ease-in-out",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              {isSidebarExpanded ? (
                <MenuOpenIcon sx={{ fontSize: 24, color: "#4f46e5" }} />
              ) : (
                <DoubleArrowIcon sx={{ fontSize: 24, color: "#4f46e5" }} />
              )}
            </IconButton>
          </div>

          {/* Logo or title */}
          <div className="flex items-center gap-2">
            { !open && <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center shadow-md">
              <span className="text-white font-bold text-sm">B</span>
            </div>}
            {!open && <Typography
              variant="h5"
              component="div"
              sx={{
                background: "linear-gradient(135deg, #1e40af 0%, #4f46e5 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                fontWeight: 700,
                fontSize: "1.5rem",
                letterSpacing: "-0.02em",
              }}
            >
              Bulk WorkFlow
            </Typography>}
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-3">
          {userDetails?.user_category === "Operations" && (
            <div className="hidden lg:flex">
              <Button
                variant="outlined"
                onClick={() => setOpenModal(true)}
                sx={{
                  px: 3,
                  py: 1,
                  borderColor: "#4f46e5",
                  color: "#4f46e5",
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#4f46e5",
                    backgroundColor: "#4f46e5",
                    color: "white",
                  },
                }}
                disabled={restrictedUser()}
              >
                Upload In Bulk
              </Button>
            </div>
          )}
          <CurrentDateAndTime />
          <Box>
            <div
              className="flex items-center gap-2 cursor-pointer px-2 py-1 rounded-lg hover:bg-gray-100 transition-all duration-200"
              onClick={handleClick}
              aria-describedby={id}
            >
              <AccountCircleIcon 
                sx={{ 
                  fontSize: 38, 
                  color: "#4f46e5",
                  filter: "drop-shadow(0 2px 4px rgba(79, 70, 229, 0.2))",
                }} 
              />
              <span className="font-semibold text-gray-800 hidden md:block">
                {userDetails?.user_name || "NA"}
              </span>
            </div>
            <Popover
              id={id}
              open={openPopup}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              PaperProps={{
                sx: {
                  mt: 1,
                  borderRadius: 2,
                  boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                  border: "1px solid rgba(0,0,0,0.05)",
                  minWidth: 220,
                }
              }}
            >
              <div className="p-4">
                <div className="text-center pb-4 border-b border-gray-200">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 mb-3 shadow-lg">
                    <AccountCircleIcon
                      sx={{
                        fontSize: 50,
                        color: "white",
                      }}
                    />
                  </div>
                  <p className="mt-2 font-semibold text-gray-800 text-base">
                    {userDetails?.user_name}
                  </p>
                  <p className="text-sm text-gray-500 mt-1">
                    {userDetails?.user_category}
                  </p>
                </div>
                <div
                  className="mt-4 flex justify-center items-center gap-2 text-red-600 hover:text-red-700 cursor-pointer py-2 px-3 rounded-lg hover:bg-red-50 transition-all duration-200 font-medium"
                  onClick={logout}
                >
                  <Logout sx={{ fontSize: 20 }} />
                  <span>Logout</span>
                </div>
              </div>
            </Popover>
          </Box>
        </div>
      </div>

      {/* ------------Modal for Upload in Bulk------------- */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "1.5rem",
            fontWeight: 600,
            color: "#1e3a8a",
            pb: 1,
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          Upload In Bulk
        </DialogTitle>
        <form onSubmit={handleSubmit(handleCSVUploadClick)}>
          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="body2"
                sx={{ mb: 1.5, fontWeight: 500, color: "#374151" }}
              >
                Select CSV File
              </Typography>
              <Box
                sx={{
                  position: "relative",
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <input
                  id="fileCSV"
                  name="fileCSV"
                  type="file"
                  accept=".csv,.xlsx"
                  {...register("file", {
                    required: "File is required...",
                  })}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: `1px solid ${errors?.file ? "#ef4444" : "#d1d5db"}`,
                    borderRadius: "8px",
                    fontSize: "14px",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (!errors?.file) {
                      e.target.style.borderColor = "#4f46e5";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!errors?.file) {
                      e.target.style.borderColor = "#d1d5db";
                    }
                  }}
                />
              </Box>
              {errors?.file && (
                <Typography
                  variant="caption"
                  sx={{
                    color: "#ef4444",
                    mt: 1,
                    display: "block",
                  }}
                >
                  {errors.file.message}
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <Button
              onClick={handleCloseModal}
              disabled={isLoading}
              sx={{
                color: "#6b7280",
                fontWeight: 500,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#f3f4f6",
                },
              }}
            >
              Close
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={isLoading}
              sx={{
                backgroundColor: "#4f46e5",
                fontWeight: 600,
                textTransform: "none",
                px: 3,
                "&:hover": {
                  backgroundColor: "#4338ca",
                },
                "&:disabled": {
                  backgroundColor: "#a5b4fc",
                },
              }}
            >
              {isLoading ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ClipLoader color="#fff" loading={isLoading} size={16} />
                  <span>Uploading...</span>
                </Box>
              ) : (
                "Upload"
              )}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
